const _ = require('lodash');
const General = require('./en/General.json');
const ConfirmationPage = require('./en/ConfirmationPage.json');
const Grid = require('./en/Grid.json');
const HotelPage = require('./en/HotelPage.json');
const ManagementPage = require('./en/ManagementPage.json');
const ManagementReportsPage = require('./en/ManagementReportsPage.json');
const NewBookingsPage = require('./en/NewBookingsPage.json');
const ReportsCFOMock = require('./en/ReportsCFOMock.json');
const ReportsPage = require('./en/ReportsPage.json');
const RequestPage = require('./en/RequestPage.json');
const ReservationPaymentPage = require('./en/ReservationPaymentPage.json');
const ResultsPage = require('./en/ResultsPage.json');
const SearchPage = require('./en/SearchPage.json');
const TravelPolicyPage = require('./en/TravelPolicyPage.json');
const UsersManagementPage = require('./en/UsersManagementPage.json');
const AboutUs = require('./en/AboutUs.json');
const ContactPage = require('./en/ContactPage.json');
const Elal = require('./en/Elal.json')

module.exports = {
	translation: _.merge(
		{},
		General,
		ConfirmationPage,
		Grid,
		HotelPage,
		ManagementPage,
		ManagementReportsPage,
		NewBookingsPage,
		ReportsCFOMock,
		ReportsPage,
		RequestPage,
		ReservationPaymentPage,
		ResultsPage,
		SearchPage,
		TravelPolicyPage,
		UsersManagementPage,
		AboutUs,
		ContactPage,
		Elal,
	),
};
